import React, { useState } from 'react'
import '../Styles/style.css'
import { useEffect } from 'react'
import openCageApi from '../ApiUtils/OpenCageApi'
import geoLocationApi from '../ApiUtils/GeoLocationApi'
import CityWeatherInfoComp from '../WeatherInfoSPA/CityWeatherInfo'
import ErrorInfoComp from '../WeatherInfoSPA/ErrorInfo'
import LoaderComp from '../WeatherInfoSPA/Loader'
import DarkSkyApi from '../ApiUtils/DarkSkyApi'
import { useQuery } from 'react-query'
import classNames from 'classnames'


const getLocationName = async(key, lat, lon) => {

    let resp = await openCageApi.getLocationName(lat, lon);
    if(resp.errorMsg != undefined){
        throw resp.errorMsg;
    }

    return  {
        name : resp,
        latitude : lat,
        longitude : lon
    };
}

const callWeatherApi = async(key, lat, lon) => {
    let resp = await DarkSkyApi.getWeatherInfo(lat, lon);
    if(resp.errorMsg != undefined){
        throw resp.errorMsg;
    }
    
    return resp;
}


const WeatherMainPageComp = (props) => {

    const [myLatitude, setMyLatitude] = useState(undefined);
    const [myLongitude, setMyLongitude] = useState(undefined);
    const [currentTabLatitude, setCurrentTabLatitude] = useState(undefined);
    const [currentTabLongitude, setCurrentTabLongitude] = useState(undefined);
    const [currentTabLocationName, setCurrentTabLocationName] = useState("");
    const [myLocationSelected, setMyLocationSelected] = useState(true);
    const [currentTabId, setCurrentTabId] = useState("tab1");

    const { data: myLocationNameData, status: myLocationNameStatus, error: myLocationNameError } = 
        useQuery(['getMyLocationName', myLatitude, myLongitude], getLocationName);

    const { data: weatherApiData, status: weatherApiDataStatus, error: weatherApiError } = 
        useQuery(['callWeatherApi', currentTabLatitude, currentTabLongitude], callWeatherApi);


    useEffect(() => {

        // Get current latitude & longitude
        const getMyCurrentLocation = async() => {
            let obj = await geoLocationApi.getLatLon();
            return obj;
        }

        getMyCurrentLocation().then(obj => {
            setMyLatitude(obj.lat);
            setMyLongitude(obj.lon);
            setCurrentTabLatitude(obj.lat);
            setCurrentTabLongitude(obj.lon);
        });
    },[])


    const changeLocation = async(e, lat, lon, cityName)=> {
        
        setCurrentTabId(e.target.id);

        setCurrentTabLatitude(lat);
        setCurrentTabLongitude(lon);
        setCurrentTabLocationName(cityName);

        if(cityName === "My Location"){
            setMyLocationSelected(true);
        }
        else{
            setMyLocationSelected(false);
        }
    }

    const componenetToShow= () =>{

        if (myLocationNameStatus === 'error') {
            // Error getting 'MyLocation' name
            return <ErrorInfoComp errorMsg={myLocationNameError} />
        }
        else if(weatherApiDataStatus === 'error'){
            // Error getting current city weather information
            return <ErrorInfoComp errorMsg={weatherApiError} />
        }
        else if (myLocationNameStatus === 'loading' || weatherApiDataStatus === 'loading') {
            // Data is still being fetched from API
            return <LoaderComp/>
        }
        else if (myLocationSelected && myLocationNameStatus === 'success' && weatherApiDataStatus === 'success') {
            // 'my location' scenario success - display fetched data
            return <CityWeatherInfoComp locationData={myLocationNameData} weatherInfo={weatherApiData}  />
        }
        else if (weatherApiDataStatus  === 'success') {
            // 'other city' scenario success - display fetched data
            let locationName ={
                name: currentTabLocationName, 
                latitude : currentTabLatitude,
                longitude : currentTabLongitude
            }

            return <CityWeatherInfoComp locationData={locationName} weatherInfo={weatherApiData}  />
        }
        else{
            return <div>Unknown error</div>
        }
    }
 
    return (
        <div>
            
            <h1>The Weather Page</h1>

            <div id="tabs_wrapper" className="tabs-wrapper">
                <button id="tab1" onClick={(e) => changeLocation(e, myLatitude, myLongitude, "My Location")} 
                    className={classNames({'tab': true, 'selected' : currentTabId === 'tab1'})} disabled={currentTabId === "tab1"}>My Location</button>
                <button id="tab2" onClick={(e) => changeLocation(e, "51.507351", "-0.127758", "London")} 
                    className={classNames({'tab': true, 'selected' : currentTabId === 'tab2'})} disabled={currentTabId === "tab2"}>London</button>
                <button id="tab3" onClick={(e) => changeLocation(e, "48.856613", "2.352222", "Paris")} 
                    className={classNames({'tab': true, 'selected' : currentTabId === 'tab3'})} disabled={currentTabId === "tab3"}>Paris</button>
                <button id="tab4" onClick={(e) => changeLocation(e, "40.712776", "-74.005974", "New York")} 
                    className={classNames({'tab': true, 'selected' : currentTabId === 'tab4'})} disabled={currentTabId === "tab4"}>New York</button>
                <button id="tab5" onClick={(e) => changeLocation(e, "55.755825", "37.617298", "Moskva")} 
                    className={classNames({'tab': true, 'selected' : currentTabId === 'tab5'})} disabled={currentTabId === "tab5"}>Moskva</button>
            </div>

            <div>
                {componenetToShow()}
            </div>

        </div>
    )
}

export default WeatherMainPageComp;